import React from 'react'
import { formatDateNoTime } from '../../AutoTrafficFineNotificationLookup/utils/formatDate'
import vehicleCar from '../../../assets/images/vehicle_car.png'
import vehicleElectricMotorbike from '../../../assets/images/vehicle_electric_motorbike.png'
import vehicleMotorbike from '../../../assets/images/vehicle_motorbike.png'

const VehicleTypeIconMap = {
  1: vehicleCar,
  30: vehicleMotorbike,
  40: vehicleElectricMotorbike
}

export default function NotifyPackageBanner({ plate, autoRenewUntil, productName, allowRenew, vehicleType }) {
  const expireText = formatDateNoTime(autoRenewUntil)
  const isAutoRenew = Number(allowRenew) === 1
  const iconSrc = VehicleTypeIconMap?.[Number(vehicleType)] || vehicleCar
  const lineText = isAutoRenew ? `Gia hạn tự động vào ${expireText || '—'}` : `Hết hạn vào ${expireText || '—'}`

  return (
    <div className="AutoTrafficFineNotificationPackageInfo_banner-wrap">
      <div className="AutoTrafficFineNotificationPackageInfo_banner">
        <div className="AutoTrafficFineNotificationPackageInfo_banner-inner">
          <div className="AutoTrafficFineNotificationPackageInfo_banner-top">
            <div className="AutoTrafficFineNotificationPackageInfo_banner-title">{productName || 'Gói thông báo'}</div>
            <img
              src={iconSrc}
              alt=""
              className="AutoTrafficFineNotificationPackageInfo_banner-vehicle"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
          </div>

          <div className="AutoTrafficFineNotificationPackageInfo_banner-bottom">
            <div className="AutoTrafficFineNotificationPackageInfo_banner-subtitle">{lineText}</div>
            <div className="AutoTrafficFineNotificationPackageInfo_banner-plate">
              <span>{plate || '—'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
